import {securedFetch} from "../auth/authService";
import {VALIDATION_RESULT_API} from "../vars";

export function acknowledgeViolations(idList) {
    return securedFetch(`${VALIDATION_RESULT_API}/acknowledge`, {idList}, 'POST');
}